import { useRef, useState } from 'react';
import CreateInvoiceHeader from './createInvoiceHeader';
import { getCurrentDate } from '../../../../../utils/dateUtils';
import InvoiceForm from './invoiceForm';
import Button from '../../../../../component/ui/Button';
import useOfflineInvoice from '../components/useOfflineSaveInvoice';
import { toast } from 'react-toastify';

const CreateInvoice = () => {
	const { saveInvoice, getInvoice, deleteInvoice, clearAllInvoices } = useOfflineInvoice();
	const [error, setError] = useState({});
	const [tableError, setTableError] = useState([]);
	const tableRef = useRef(null);
	const [isDraft, setIsDraft] = useState(false);
	const [isSetOfflineInvoice, setIsSetOfflineInvoice] = useState(true);
	const [additionDiscountAndTax, setAdditionDiscountAndTax] = useState({
		discount: null,
		adj: null,
		round_off: null,
	});
	const [invoice, setInvoice] = useState({
		customer_id: null,
		doctor_id: null,
		invoice_number: '',
		date: getCurrentDate(),
		sale_order_id: null,
		remarks: '',
		payment_method: null,
		due_date: null,
	});
	const [invoiceTable, setInvoiceTable] = useState([]);

	function totalDiscountAmount() {
		let amount = invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0);
		let totalDiscount = (amount * Number(additionDiscountAndTax.discount ?? 0)) / 100;
		return totalDiscount;
	}
	function totalTaxesAmount() {
		let totalTax1 = invoiceTable?.reduce(
			(sum, item) =>
				Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax1 ?? 0)) / 100,
			0,
		);
		let totalTax2 = invoiceTable?.reduce(
			(sum, item) =>
				Number(sum) + (Number(item.amount ?? 0) * Number(item.product_tax2 ?? 0)) / 100,
			0,
		);
		return Number(totalTax1) + Number(totalTax2);
	}
	function totalAmount() {
		let amount = invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0);
		let totalTaxes = totalTaxesAmount();
		let totalAmountWithDiscount =
			amount - (amount * Number(additionDiscountAndTax.discount ?? 0)) / 100;
		let totalAmountWithTax = Number(totalAmountWithDiscount) + Number(totalTaxes);
		return (
			Number(totalAmountWithTax) -
			Number(additionDiscountAndTax.adj ?? 0) -
			Number(additionDiscountAndTax.round_off ?? 0)
		);
	}
	const calculateAmount = () => {
		return invoiceTable?.reduce((sum, item) => Number(sum) + Number(item.amount), 0);
	};

	const getOfflineInvoiceData = async () => {
		try {
			const data = await getInvoice();
			if (data !== undefined && data) {
				const form = {
					customer_id: data.customer_id,
					doctor_id: data.doctor_id,
					invoice_number: data.invoice_number,
					date: data.date,
					sale_order_id: data.sale_order_id,
					remarks: data.remarks,
					payment_method: data.payment_method,
					due_date: data.due_date,
				};
				setInvoiceTable(data.invoiceTable);
				setInvoice(form);
				setIsSetOfflineInvoice(false);
			}
		} catch (error) {
			toast.error(error);
		}
	};

	return (
		<div>
			<div className="">
				<CreateInvoiceHeader
					totalDiscountAmount={totalDiscountAmount}
					totalTaxesAmount={totalTaxesAmount}
					totalAmount={totalAmount}
					calculateAmount={calculateAmount}
					additionDiscountAndTax={additionDiscountAndTax}
					error={error}
					setError={setError}
					tableError={tableError}
					setTableError={setTableError}
					invoice={invoice}
					setInvoice={setInvoice}
					invoiceTable={invoiceTable}
					setInvoiceTable={setInvoiceTable}
					setIsSetOfflineInvoice={setIsSetOfflineInvoice}
					saveInvoice={saveInvoice}
					clearAllInvoices={clearAllInvoices}
					getInvoice={getInvoice}
					isSetOfflineInvoice={isSetOfflineInvoice}
					isDraft={isDraft}
				/>
				{isSetOfflineInvoice && (
					<div
						style={{
							backgroundColor: '#FFC008',
							padding: '5px 20px',
							display: 'flex',
							justifyContent: 'space-between',
							alignItems: 'center',
						}}
					>
						<div
							style={{ color: '#000', fontSize: '14px', fontWeight: '600', marginRight: '10px' }}
						>
							Action Required: Your latest data was saved due to network issue. Due you want to
							restore it back or clear?
						</div>
						<div className="d-flex">
							<Button
								type="button"
								className="mx-1 btn-gray add-pro"
								button="Clear"
								onClick={async () => {
									await clearAllInvoices();
									setIsSetOfflineInvoice(false);
								}}
							/>
							<div className="mx-2" />
							<Button
								type="button"
								className="mt-0 btn-primary add-pro"
								button="Restore"
								onClick={async () => {
									await getOfflineInvoiceData();
									await clearAllInvoices();
									setIsSetOfflineInvoice(false);
								}}
							/>
						</div>
					</div>
				)}
				<InvoiceForm
					setInvoice={setInvoice}
					invoice={invoice}
					error={error}
					setError={setError}
					setIsDraft={setIsDraft}
					isDraft={isDraft}
					setInvoiceTable={setInvoiceTable}
					setAdditionDiscountAndTax={setAdditionDiscountAndTax}
					tableRef={tableRef}
					invoiceTable={invoiceTable}
					tableError={tableError}
					setTableError={setTableError}
					additionDiscountAndTax={additionDiscountAndTax}
					totalDiscountAmount={totalDiscountAmount}
					totalTaxesAmount={totalTaxesAmount}
					totalAmount={totalAmount}
					calculateAmount={calculateAmount}
				/>
			</div>
		</div>
	);
};
export default CreateInvoice;
